import PropTypes from 'prop-types';
import React from 'react';
import Media from 'react-media';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import IconButton from '../../../components/common/IconButton';
import DrawerToggle from '../../../components/layout/drawer/DrawerToggle';
import { getPathname } from '../../../modules/app/selectors';
import { isAuthorized } from '../../../modules/user/selectors';
import { BETTING_BUDDY, DEFAULT, HOME, NOT_FOUND, SAVED_SLIPS } from '../../../routes/paths';

export const HeaderMenuButton = ({ authorized, path, history }) => {
  if (path === NOT_FOUND) {
    return '';
  }

  if (!authorized) {
    return (
      <div className="header-button">
        <IconButton
          iconClassName="material-icon material-icon--arrow-back"
          onClick={() => history.push(DEFAULT)}
        />
      </div>
    );
  }

  if (path === BETTING_BUDDY || path === SAVED_SLIPS) {
    return (
      <div className="header-button">
        <Media query={{ minWidth: 966 }}>
          {matches => !matches && (
            <IconButton
              iconClassName="icon-button__icon--small icon icon--home"
              onClick={() => history.push(HOME)}
            />
          )}
        </Media>
      </div>
    );
  }

  return (
    <div className="header-button">
      <Media query={{ minWidth: 966 }}>
        {matches => !matches && (
          <DrawerToggle>
            {toggle => (
              <IconButton
                iconClassName="material-icon material-icon--menu"
                onClick={() => toggle('nav')}
              />
            )}
          </DrawerToggle>
        )}
      </Media>
    </div>
  );
};

HeaderMenuButton.propTypes = {
  authorized: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};

export default withRouter(
  connect(state => ({
    path: getPathname(state),
    authorized: isAuthorized(state)
  }))(HeaderMenuButton)
);
